import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ReloadButton from './ReloadButton';
import UpconfigButton from './UpconfigButton';
import { isSolrCloud } from '../../../utils/utils';
import SelectDropdown from '../../sections/select-dropdown/SelectDropdown';

const ConfigCollectionSelect = ({
  collections,
  instanceType,
  onCollectionChange,
  selectedCollection,
}) => {
  const { t } = useTranslation();

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <SelectDropdown
          title={`${t('collection', { ns: 'instance' })}: `}
          selectList={collections || []}
          value={selectedCollection}
          isControlled={true}
          onChange={onCollectionChange}
        />
        {isSolrCloud(instanceType) && (
          <UpconfigButton selectedCollection={selectedCollection} />
        )}
        <ReloadButton selectedCollection={selectedCollection} />
      </Box>
    </section>
  );
};

ConfigCollectionSelect.propTypes = {
  collections: PropTypes.array,
  instanceType: PropTypes.string,
  onCollectionChange: PropTypes.func.isRequired,
  selectedCollection: PropTypes.string.isRequired,
};

export default ConfigCollectionSelect;
